import React, { Component } from 'react';
import './InsurerStep.css';
import FaAngleDown from 'react-icons/lib/fa/angle-down';
import InputField from '../../../../components/Input-field/InputField';
import { Field, reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import FaArrowCircleOLeft from 'react-icons/lib/fa/arrow-circle-o-left';
import FaArrowCircleORight from 'react-icons/lib/fa/arrow-circle-o-right';
import api from '../../../../api/index';
import { mapToOptions } from '../../../../utils/index';
import InputSelect from '../../../../components/Input-select/InputSelect';
import { getTranslate } from 'react-localize-redux';
import SelectCarCard from '../../../../components/Select-car-card/SelectCarCard';
import SelectedCarCardMobile from '../../../../components/Select-Car-Card-Mobile/SelectCarCardMobile';
import SelectedCarCardSmMobile from '../../../../components/Select-Car-Card-Sm-Mobile/SelectCarCardSmMobile'
import PolicyRegScrollbar from '../../../../components/PolicyRegScrollbar/PolicyRegScrollbar'
import { SubmissionError } from 'redux-form';
import ReactTooltip from 'react-tooltip'
const validate = values => {
	const errors = {};

	if (!values.vehicleDriverName) {
		errors.vehicleDriverName = 'fillInput';
	} else if (
		/[^a-z ]/i.test(values.vehicleDriverName)
	) {
		errors.vehicleDriverName = 'typeInLatinUnicode';
	}

	if (!values.vehicleDriverLastname) {
		errors.vehicleDriverLastname = 'fillInput';
	} else if (
		/[^a-z ]/i.test(values.vehicleDriverLastname)
	) {
		errors.vehicleDriverLastname = 'typeInLatinUnicode';
	}

	if (!values.vehicleDriverPassportNumber) {
		errors.vehicleDriverPassportNumber = 'fillInput';
	} else if (
		/[^a-z ]/i.test(values.vehicleDriverPassportNumber)
	) {
		errors.vehicleDriverPassportNumber = 'typeInLatinUnicode';
	}
	if (!values.vehicleDriverPersonalNumber) {
		errors.vehicleDriverPersonalNumber = 'fillInput';
	} else if (
		/[^a-z ]/i.test(values.vehicleDriverPersonalNumber)
	) {
		errors.vehicleDriverPersonalNumber = 'typeInLatinUnicode';
	}

	if (!values.vehicleDriverPhoneNumber && !values.vehicleDriverEmail) {
		errors.vehicleDriverPhoneNumber = 'fillInput';
		errors.vehicleDriverEmail = 'fillInput';
	}

	if (values.vehicleDriverPhoneNumber && values.vehicleDriverPhoneNumber.length > 20) {
		errors.vehicleDriverPhoneNumber = 'max20Symbols';
	}

	if (values.vehicleDriverPhoneNumber && /[^0-9+ -]/i.test(values.vehicleDriverPhoneNumber)) {
		errors.vehicleDriverPhoneNumber = 'insertNumbers';
	}

	if (values.vehicleDriverPhoneNumber && /[^0-9+ -]/i.test(values.vehicleDriverPhoneNumber)) {
		errors.vehicleDriverPhoneNumber = 'insertNumbers';
	}

	if (!values.vehicleDriverIdentificationNumber) {
		errors.vehicleDriverIdentificationNumber = 'fillInput';
	}

	if (values.vehicleDriverEmail && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.vehicleDriverEmail)) {
		errors.vehicleDriverEmail = 'correctEmailFormat';
	}

	if (!values.vehicleDriverCitizenshipId) {
		errors.vehicleDriverCitizenshipId = 'chooseField';
	}
	if (!values.vehicleOwnerName) {
		errors.vehicleOwnerName = 'fillInput';
	} else if (
		/[^a-z ]/i.test(values.vehicleOwnerName)
	) {
		errors.vehicleOwnerName = 'typeInLatinUnicode';
	}
	if (!values.vehicleOwnerLastname) {
		errors.vehicleOwnerLastname = 'fillInput';
	} else if (
		/[^a-z ]/i.test(values.vehicleOwnerLastname)
	) {
		errors.vehicleOwnerLastname = 'typeInLatinUnicode';
	}
	if (!values.vehicleOwnerType) {
		errors.vehicleOwnerType = 'fillInput';
	} else if (
		/[^a-z ]/i.test(values.vehicleOwnerType)
	) {
		errors.vehicleOwnerType = 'typeInLatinUnicode';
	}
	if (!values.vehicleOwnerIdentificationNumber) {
		errors.vehicleOwnerIdentificationNumber = 'fillInput';
	}
	if (values.vehicleOwnerEmail && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.vehicleOwnerEmail)) {
		errors.vehicleOwnerEmail = 'correctEmailFormat';
	}

	if (!values.vehicleOwnerPhone && !values.vehicleOwnerEmail) {
		errors.vehicleOwnerPhone = 'fillInput';
		errors.vehicleOwnerEmail = 'fillInput';
	}

	if (values.vehicleOwnerPhone && values.vehicleOwnerPhone.length > 20) {
		errors.vehicleOwnerPhone = 'max20Symbols';
	}

	if (values.vehicleOwnerPhone && /[^0-9+ -]/i.test(values.vehicleOwnerPhone)) {
		errors.vehicleOwnerPhone = 'insertNumbers';
	}

	if (!values.vehicleOwnerCitizenshipId) {
		errors.vehicleOwnerCitizenshipId = 'chooseField';
	}
	if (!values.insurerName) {
		errors.insurerName = 'fillInput';
	} else if (
		/[^a-z ]/i.test(values.insurerName)
	) {
		errors.insurerName = 'typeInLatinUnicode';
	}
	if (!values.insurerLastname) {
		errors.insurerLastname = 'fillInput';
	} else if (
		/[^a-z ]/i.test(values.insurerLastname)
	) {
		errors.insurerLastname = 'typeInLatinUnicode';
	}

	if (!values.insurerIdentificationNumber) {
		errors.insurerIdentificationNumber = 'fillInput';
	}

	if (values.insurerIdentificationNumber && /[^a-z0-9]/i.test(values.insurerIdentificationNumber)) {
		errors.insurerIdentificationNumber = 'inputInEnglish';
	}
	if (values.insurerIdentificationNumber && /[^a-z ]/i.test(values.insurerName)) {
		errors.insurerIdentificationNumber = 'typeInLatinUnicode';
	}

	if (!values.insurerPhone && !values.insurerEmail) {
		errors.insurerPhone = 'fillInput';
		errors.insurerEmail = 'fillInput';
	}

	if (values.insurerPhone && /[^0-9+ -]/i.test(values.insurerPhone)) {
		errors.insurerPhone = 'insertNumbers';
	}

	if (values.insurerPhone && values.insurerPhone.length > 20) {
		errors.insurerPhone = 'max20Symbols';
	}

	if (!values.insurerEmail && !values.insurerPhone) {
		errors.insurerEmail = 'fillInput';
	}

	if (values.insurerEmail && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.insurerEmail)) {
		errors.insurerEmail = 'correctEmailFormat';
	}

	if (!values.vehicleDriverTitle) {
		errors.vehicleDriverTitle = 'fillInput';
	}

	if (!values.insurerCitizenshipId) {
		errors.insurerCitizenshipId = 'chooseField';
	}

	if (!values.driverAndInsurerIdentity) {
		errors.driverAndInsurerIdentity = 'fillInput';
	}

	if (!values.ownerAndInsurerIdentity) {
		errors.ownerAndInsurerIdentity = 'fillInput';
	}

	if (!values.insurerTitle || values.insurerTitle.trim().length === 0) {
		errors.insurerTitle = 'fillInput';
	}

	if (values.insurerTitle && values.insurerTitle.length > 100) {
		errors.insurerTitle = 'max100Symbols'
	}

	if (values.insurerTitle && values.driverAndInsurerIdentity !== "N" && /[^a-z ]/i.test(values.insurerTitle)) {
		errors.insurerTitle = 'typeInLatinUnicode';

	} else if (values.insurerTitle && values.driverAndInsurerIdentity && /[^a-z0-9 ]/i.test(values.insurerTitle)) {
		errors.insurerTitle = 'typeInLatinUnicode';
	}

	return errors;
};

class InsurerStep extends Component {
	constructor() {
		super();
		this.state = {
			countries: [],
			driverAndInsurerIdentityError: '',
			ownerAndInsurerIdentityError: '',
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		api.vehicle.countries().then(({ data }) => {
			this.setState({
				countries: mapToOptions(data),
			});
		});
	}

	onOwnerInfo = () => {
		this.props.dispatch(change('CreatePolicyForm', 'vehicleOwnerType', this.props.insurerType));
		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'vehicleOwnerTitle',
				this.props.insurerTitle
			)
		);

		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'vehicleOwnerIdentificationNumber',
				this.props.insurerIdentificationNumber
			)
		);
		this.props.dispatch(
			change('CreatePolicyForm', 'vehicleOwnerPhone', this.props.insurerPhone)
		);
		this.props.dispatch(
			change('CreatePolicyForm', 'vehicleOwnerEmail', this.props.insurerEmail)
		);
		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'vehicleOwnerCitizenshipId',
				this.props.insurerCitizenshipId
			)
		);
		this.setState({
			ownerAndInsurerIdentityError: '',
		});
	};


	resetOwnerInfo = () => {
		this.props.dispatch(change('CreatePolicyForm', 'vehicleOwnerType', 'I'));
		this.props.dispatch(change('CreatePolicyForm', 'vehicleOwnerTitle', ''));
		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'vehicleOwnerIdentificationNumber',
				''
			)
		);
		this.props.dispatch(
			change('CreatePolicyForm', 'vehicleOwnerPhone', '')
		);
		this.props.dispatch(
			change('CreatePolicyForm', 'vehicleOwnerEmail', '')
		);
		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'vehicleOwnerCitizenshipId',
				''
			)
		);
		this.setState({
			ownerAndInsurerIdentityError: '',
		});
	};


	onVehicleDriverInfo = () => {
		this.props.dispatch(
			change('CreatePolicyForm', 'vehicleDriverTitle', this.props.insurerTitle)
		);

		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'vehicleDriverIdentificationNumber',
				this.props.insurerIdentificationNumber
			)
		);
		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'vehicleDriverPhoneNumber',
				this.props.insurerPhone
			)
		);
		this.props.dispatch(
			change('CreatePolicyForm', 'vehicleDriverEmail', this.props.insurerEmail)
		);
		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'vehicleDriverCitizenshipId',
				this.props.insurerCitizenshipId
			)
		);
		this.setState({
			driverAndInsurerIdentityError: '',
		});
	};
	resetVehicleDriverInfo = () => {
		this.props.dispatch(
			change('CreatePolicyForm', 'vehicleDriverTitle', '')
		);
		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'vehicleDriverIdentificationNumber',
				''
			)
		);
		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'vehicleDriverPhoneNumber',
				''
			)
		);
		this.props.dispatch(
			change('CreatePolicyForm', 'vehicleDriverEmail', '')
		);
		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'vehicleDriverCitizenshipId',
				''
			)
		);
		this.setState({
			driverAndInsurerIdentityError: '',
		});
	};
	render() {
		const {
			error,
			handleSubmit,
			submitting,
			previousPage,
			translate,
			insurerType,
			vehicleOwnerType
		} = this.props;
		return (
			<div className="policy-registration-container">
				<div className="policy-create-card" id="policy-create-card">
					<PolicyRegScrollbar numb={3} />
					<SelectedCarCardMobile />
					<SelectedCarCardSmMobile />
					<form onSubmit={handleSubmit}>
						<div>
							<div className="collapse-content">
								<h5 className="collapse-content-header">
									{translate('insurer')}
								</h5>
							</div>
							<div className="collapsible-policy">
								<div className="input-radio-group input-radio-group-padded">
									<div className="input-radio">
										<label className="input-radio-label">
											<Field
												name="insurerType"
												value="I"
												component="input"
												type="radio"
												onChange={() => {
													this.props.dispatch(change('CreatePolicyForm', 'insurerTitle', ''));
													this.props.dispatch(change('CreatePolicyForm', 'ownerAndInsurerIdentity', 'Y'));
													this.props.dispatch(change('CreatePolicyForm', 'driverAndInsurerIdentity', 'Y'));
												}}
											/>
											<span className="input-radio-circle" />
											<span className="input-radio-text">
												{translate('individualPerson')}
											</span>
										</label>
									</div>
									<div className="input-radio">
										<label className="input-radio-label">
											<Field
												name="insurerType"
												value="L"
												component="input"
												type="radio"
												onChange={() => {
													this.props.dispatch(change('CreatePolicyForm', 'insurerTitle', ''));
													this.props.dispatch(change('CreatePolicyForm', 'ownerAndInsurerIdentity', 'N'));
													this.props.dispatch(change('CreatePolicyForm', 'driverAndInsurerIdentity', 'N'));
												}}
											/>
											<span className="input-radio-circle" />
											<span className="input-radio-text">
												{translate('legalPerson')}
											</span>
										</label>
									</div>
								</div>

								<div className="fields insurerTitle-fields">
									<div className="collapse-header-insurerTitle">
										<Field
											name="insurerTitle"
											labelName={'insurerTitle'}
											component={InputField}
											id={1000}
											placeholder={''}
											type="text"
										/>
									</div>
									<div className="insurer-collapse-container">
										<div className="collapse">
											<a data-tip
												data-for='idFacrNumber'>
												<Field
													name="insurerIdentificationNumber"
													labelName={'insurerIdentificationNumber'}
													component={InputField}
													id={4000}
													placeholder={''}
													type="text"

												/>
											</a>
											<ReactTooltip id='idFacrNumber' type="success" effect='solid' place="right" >
												<div className="tooltip">
													<div className="category-description-text">
														{/*<p>მიუთითეთ პირადი ნომერი ან </p>*/}
														{/*<p> საზღვარგარეთის პასპორტის ნომერი</p>*/}
														{translate('spedifyPersonalNumber')}
													</div>
												</div>
											</ReactTooltip>

											<Field
												name="insurerCitizenshipId"
												labelName={'insurerCitizenshipId'}
												onChange={(event, value) => {
													this.state.countries.forEach(item => {
														if (item.value === value) {
															this.props.dispatch(
																change(
																	'CreatePolicyForm',
																	'insurerCitizenshipName',
																	item.label
																)
															);
														}
													});
												}}
												options={this.state.countries}
												component={InputSelect}
												id={1004}
												placeholder={''}
												type="text"
											/>

										</div>
										<div className="collapse second">
											<Field
												name="insurerPhone"
												labelName={'insurerPhone'}
												component={InputField}
												id={1002}
												placeholder={''}
												type="text"
											/>
											<Field
												name="insurerEmail"
												labelName={'insurerEmail'}
												component={InputField}
												id={1003}
												placeholder={''}
												type="text"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="identity-container">
							<label className="identity-container-label">
								{translate('driverAndInsurerIdentify')} ?
              </label>
							<div className="identity-container-content">
								<div className="input-radio-group">
									<div className="input-radio">
										<label className="input-radio-label">
											<Field
												name="driverAndInsurerIdentity"
												value="Y"
												component="input"
												type="radio"
												onChange={() => {
													this.onVehicleDriverInfo();
												}}
											/>
											<span className="input-radio-circle" />
											<span className="input-radio-text"> {translate('yes')}</span>
										</label>
									</div>
									<div className="input-radio">
										<label className="input-radio-label">
											<Field
												name="driverAndInsurerIdentity"
												value="N"
												component="input"
												type="radio"
												onChange={() => {
													this.setState({
														driverAndInsurerIdentityError: '',
													});
													this.resetVehicleDriverInfo()
												}}
											/>
											<span className="input-radio-circle" />
											<span className="input-radio-text">{translate('no')}</span>
										</label>
									</div>
								</div>
							</div>
						</div>

						{this.props.driverAndInsurerIdentity === 'N' && (
							<div>
								<div className="collapse-content">
									<h5 className="collapse-content-header">
										{translate('driver')}
									</h5>
								</div>
								<div className="collapsible-policy">
									<div className="fields">
										<div className="collapse">
											<Field
												name="vehicleDriverTitle"
												labelName={'vehicleDriverTitle'}
												component={InputField}
												id={1}
												placeholder={''}
												type="text"
											/>
											<Field
												name="vehicleDriverIdentificationNumber"
												labelName={'vehicleDriverIdentificationNumber'}
												component={InputField}
												id={4}
												placeholder={''}
												type="text"
											/>
										</div>
										<div className="collapse second">
											<Field
												name="vehicleDriverPhoneNumber"
												labelName={'vehicleDriverPhoneNumber'}
												component={InputField}
												id={11}
												placeholder={''}
												type="text"
											/>
											<Field
												name="vehicleDriverEmail"
												labelName={'vehicleDriverEmail'}
												component={InputField}
												id={12}
												placeholder={''}
												type="text"
											/>
											<Field
												name="vehicleDriverCitizenshipId"
												labelName={'vehicleDriverCitizenshipId'}
												onChange={(event, value) => {
													this.state.countries.forEach(item => {
														if (item.value === value) {
															this.props.dispatch(
																change(
																	'CreatePolicyForm',
																	'vehicleDriverCitizenshipName',
																	item.label
																)
															);
															this.props.dispatch(
																change(
																	'CreatePolicyForm',
																	'vehicleOwnerCitizenshipName',
																	item.label
																)
															);
															this.props.dispatch(
																change(
																	'CreatePolicyForm',
																	'insurerCitizenshipName',
																	item.label
																)
															);
														}
													});
												}}
												options={this.state.countries}
												component={InputSelect}
												id={13}
												placeholder={''}
												type="text"
											/>
										</div>
									</div>
								</div>
							</div>
						)}
						<div className="identity-container">
							<label className="identity-container-label">
								{translate('ownerAndInsurerIdentify')} ?
              </label>
							<div className="identity-container-content">
								<div className="input-radio-group">
									<div className="input-radio">
										<label className="input-radio-label">
											<Field
												name="ownerAndInsurerIdentity"
												value="Y"
												component="input"
												type="radio"
												onChange={() => {
													this.onOwnerInfo();
												}}
											/>
											<span className="input-radio-circle" />
											<span className="input-radio-text"> {translate('yes')}</span>
										</label>
									</div>
									<div className="input-radio">
										<label className="input-radio-label">
											<Field
												name="ownerAndInsurerIdentity"
												value="N"
												component="input"
												type="radio"
												onChange={() => {
													this.setState({
														ownerAndInsurerIdentityError: '',
													});
													this.resetOwnerInfo()
												}}
											/>
											<span className="input-radio-circle" />
											<span className="input-radio-text">{translate('no')}</span>
										</label>
									</div>
								</div>
							</div>
						</div>
						{this.props.ownerAndInsurerIdentity === 'N' && (
							<div>
								<div className="collapse-content">
									<h5 className="collapse-content-header">
										{translate('owner')}
									</h5>
								</div>
								<div className="collapsible-policy">
									<div className="input-radio-group input-radio-group-padded">
										<div className="input-radio">
											<label className="input-radio-label">
												<Field
													name="vehicleOwnerType"
													value="I"
													component="input"
													type="radio"

												/>
												<span className="input-radio-circle" />
												<span className="input-radio-text">
													{translate('individualPerson')}
												</span>
											</label>
										</div>
										<div className="input-radio">
											<label className="input-radio-label">
												<Field
													name="vehicleOwnerType"
													value="L"
													component="input"
													type="radio"
												/>
												<span className="input-radio-circle" />
												<span className="input-radio-text">
													{translate('legalPerson')}
												</span>
											</label>
										</div>
									</div>
									<div className="fields">
										<div className="collapse">
											<Field
												name="vehicleOwnerTitle"
												labelName={'vehicleOwnerTitle'}
												component={InputField}
												id={10}
												placeholder={''}
												type="text"
											/>
											<Field
												name="vehicleOwnerIdentificationNumber"
												labelName={'vehicleOwnerIdentificationNumber'}
												component={InputField}
												id={102}
												placeholder={''}
												type="text"
											/>
										</div>
										<div className="collapse second">
											<Field
												name="vehicleOwnerPhone"
												labelName={'vehicleOwnerPhone'}
												component={InputField}
												id={103}
												placeholder={''}
												type="text"
											/>
											<Field
												name="vehicleOwnerEmail"
												labelName={'vehicleOwnerEmail'}
												component={InputField}
												id={104}
												placeholder={''}
												type="text"
											/>
											<Field
												name="vehicleOwnerCitizenshipId"
												labelName={'vehicleOwnerCitizenshipId'}
												options={this.state.countries}
												onChange={(event, value) => {
													this.state.countries.forEach(item => {
														if (item.value === value) {
															this.props.dispatch(
																change(
																	'CreatePolicyForm',
																	'vehicleOwnerCitizenshipName',
																	item.label
																)
															);
														}
													});
												}}
												component={InputSelect}
												id={105}
												placeholder={''}
												type="text"
											/>
										</div>
									</div>
								</div>
							</div>
						)}
						<div className="container step-btn-content">
							<button className="back-btn" onClick={previousPage}>
								{translate('back')}
							</button>
							<button
								className="next-btn"
								type="submit"
								onClick={() => {
									if (this.props.driverAndInsurerIdentity === 'Y') {
										this.onVehicleDriverInfo();
									}
									if (this.props.ownerAndInsurerIdentity === 'Y') {
										this.onOwnerInfo();
									}
								}}
							>
								{translate('next')}
							</button>
						</div>
					</form>
				</div>
				<SelectCarCard />
			</div>
		);
	}
}

InsurerStep = reduxForm({
	validate,
	form: 'CreatePolicyForm', // a unique identifier for this form
	forceUnregisterOnUnmount: true,
	destroyOnUnmount: false,
})(InsurerStep);

const selector = formValueSelector('CreatePolicyForm');

const mapStateToProps = state => {
	const insurerTitle = selector(state, 'insurerTitle');
	const vehicleDriverPassportNumber = selector(
		state,
		'vehicleDriverPassportNumber'
	);
	const insurerPhone = selector(state, 'insurerPhone');
	const insurerEmail = selector(state, 'insurerEmail');
	const insurerCitizenshipId = selector(state, 'insurerCitizenshipId');
	const insurerIdentificationNumber = selector(
		state,
		'insurerIdentificationNumber'
	);
	const insurerType = selector(state, 'insurerType');
	const vehicleOwnerType = selector(state, 'vehicleOwnerType');
	const driverAndInsurerIdentity = selector(state, 'driverAndInsurerIdentity');
	const ownerAndInsurerIdentity = selector(state, 'ownerAndInsurerIdentity');
	return {
		insurerTitle,
		vehicleDriverPassportNumber,
		insurerPhone,
		insurerEmail,
		insurerCitizenshipId,
		insurerIdentificationNumber,
		insurerType,
		vehicleOwnerType,
		driverAndInsurerIdentity,
		ownerAndInsurerIdentity,
		translate: getTranslate(state.locale),
	};
};

export default connect(mapStateToProps)(InsurerStep);



// WEBPACK FOOTER //
// ./src/pages/PoliciesCreatePage/steps/InsurerStep/InsurerStep.js